export default "https://private-05627-frontendnewhire.apiary-mock.com/contact_list";
